import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { useTranslation } from "react-i18next";
import { Icons } from "assets/icons";
import {
  emptyDonut,
  getTotalValue,
  tooltipContentStyle,
  tooltipCursorStyle,
} from "utils/dashboardUtils";

const SentimentAnalysis = ({ feedbacks }) => {
  const { t } = useTranslation();
  const SENTIMENT_DATA = feedbacks ?? {
    rating: 0,
    label: "N/A",
    chart: [],
    breakdown: [],
  };
  const { rating, label, chart, breakdown } = SENTIMENT_DATA;
  const { starBlack } = Icons || {};

  const totalValue = getTotalValue(chart);

  const chartData = totalValue === 0 ? emptyDonut : chart;

  return (
    <div className="sentiment_card dashboard_common_card">
      <h3 className="fs_20">{t("Sentiment Analysis")}</h3>

      {/* Donut */}
      <div className="sentiment_chart">
        <ResponsiveContainer width={200} height={200}>
          <PieChart>
            <Pie
              data={chartData}
              innerRadius={60}
              outerRadius={80}
              dataKey="value"
              startAngle={90}
              endAngle={-270}
            >
              {chartData.map((entry, i) => (
                <Cell key={i} fill={entry.color} />
              ))}
            </Pie>
            {totalValue > 0 && (
              <Tooltip
                cursor={tooltipCursorStyle}
                formatter={(value, name) => [`${value}%`, t(name)]}
                contentStyle={tooltipContentStyle}
              />
            )}
          </PieChart>
        </ResponsiveContainer>

        <div className="sentiment_center">
          {totalValue === 0 ? (
            <p>{t("No Sentiment Data")}</p>
          ) : (
            <>
              <img src={starBlack} width={24} height={24} className="star" />
              <h4>{rating}</h4>
              <p>{t(label)}</p>
            </>
          )}
        </div>
      </div>

      {/* Breakdown */}
      <div className="sentiment_breakdown">
        {breakdown.map((item) => (
          <div key={item.label} className="sentiment_row">
            <div className="sentiment_row__top">
              <span>{t(item.label)}</span>
              <span>{item.value}</span>
            </div>

            <div className="sentiment_bar">
              <span
                className="sentiment_bar__fill"
                style={{
                  "--target-width": `${item.percent}%`,
                  background: item.color,
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SentimentAnalysis;
